/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Meta_TitleInputs */

const id_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang - egdata.app`)
};

const ms_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perihal - egdata.app`)
};

const da_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om - egdata.app`)
};

const de_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über - egdata.app`)
};

const en_us2_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About - egdata.app`)
};

const es_es2_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de - egdata.app`)
};

const es_mx2_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de - egdata.app`)
};

const fil_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol Sa - egdata.app`)
};

const fr_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos - egdata.app`)
};

const it_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni - egdata.app`)
};

const hu_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Névjegy - egdata.app`)
};

const nl_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over - egdata.app`)
};

const no_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om - egdata.app`)
};

const pl_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nas - egdata.app`)
};

const pt_br2_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre - egdata.app`)
};

const pt_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre - egdata.app`)
};

const ro_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despre - egdata.app`)
};

const fi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa - egdata.app`)
};

const sv_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om - egdata.app`)
};

const vi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới thiệu - egdata.app`)
};

const tr_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında - egdata.app`)
};

const cs_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nás - egdata.app`)
};

const bg_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Относно - egdata.app`)
};

const ru_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О проекте — egdata.app`)
};

const uk_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про нас - egdata.app`)
};

const ar_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حول - egdata.app`)
};

const hi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे बारे में - egdata.app`)
};

const th_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ - egdata.app`)
};

const ja_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要 - egdata.app`)
};

const zh_cn2_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 - egdata.app`)
};

const zh_hant1_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於 - egdata.app`)
};

const ko_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소개 - egdata.app`)
};

/**
* | output |
* | --- |
* | "About - egdata.app" |
*
* @param {About_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_meta_title = /** @type {((inputs?: About_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_meta_title(inputs)
	if (locale === "ms") return ms_about_meta_title(inputs)
	if (locale === "da") return da_about_meta_title(inputs)
	if (locale === "de") return de_about_meta_title(inputs)
	if (locale === "en-US") return en_us2_about_meta_title(inputs)
	if (locale === "es-ES") return es_es2_about_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_about_meta_title(inputs)
	if (locale === "fil") return fil_about_meta_title(inputs)
	if (locale === "fr") return fr_about_meta_title(inputs)
	if (locale === "it") return it_about_meta_title(inputs)
	if (locale === "hu") return hu_about_meta_title(inputs)
	if (locale === "nl") return nl_about_meta_title(inputs)
	if (locale === "no") return no_about_meta_title(inputs)
	if (locale === "pl") return pl_about_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_about_meta_title(inputs)
	if (locale === "pt") return pt_about_meta_title(inputs)
	if (locale === "ro") return ro_about_meta_title(inputs)
	if (locale === "fi") return fi_about_meta_title(inputs)
	if (locale === "sv") return sv_about_meta_title(inputs)
	if (locale === "vi") return vi_about_meta_title(inputs)
	if (locale === "tr") return tr_about_meta_title(inputs)
	if (locale === "cs") return cs_about_meta_title(inputs)
	if (locale === "bg") return bg_about_meta_title(inputs)
	if (locale === "ru") return ru_about_meta_title(inputs)
	if (locale === "uk") return uk_about_meta_title(inputs)
	if (locale === "ar") return ar_about_meta_title(inputs)
	if (locale === "hi") return hi_about_meta_title(inputs)
	if (locale === "th") return th_about_meta_title(inputs)
	if (locale === "ja") return ja_about_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_about_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_meta_title(inputs)
	return ko_about_meta_title(inputs)
});
export { about_meta_title as "about.meta.title" }